/**

Coded by www.techhighway.ca

*/

import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for MDInput
import MDInputRoot from "components/MDInput/MDInputRoot";

const MDInput = forwardRef(({ error, success, disabled, readOnly, size, ...rest }, ref) => (
  <MDInputRoot
    {...rest}
    size={size}
    ref={ref}
    ownerState={{ error, success, disabled, readOnly }}
    onFocus={(e) => e.target.select()}
  />
));

// Setting default values for the props of MDInput
MDInput.defaultProps = {
  error: false,
  success: false,
  disabled: false,
  readOnly: false,
  size: "small",
  autoComplete: "off",
};

// Typechecking props for the MDInput
MDInput.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default MDInput;
